export const MovementTypeCodes = {
    Inclusion: 'I',
    Change: 'A',
    Exclusion: 'E',
    Unknown: 'U'
};

export type MovementTypeCode = (typeof MovementTypeCodes)[keyof typeof MovementTypeCodes];
